const mixin = {
  methods: {
    getDate (date) {
      return date ? date.split(' ')[0] : null
    },
    getTime (date) {
      return date ? date.split(' ')[1] : null
    },
    getTimeMin (date) {
      return date ? this.getHours(date) + ':' + this.getMinutes(date) : null
    },
    getDay (date) {
      return date ? date.split(' ')[0].split('/')[0] : null
    },
    getMonth (date) {
      return date ? date.split(' ')[0].split('/')[1] : null
    },
    getYear (date) {
      return date ? date.split(' ')[0].split('/')[2] : null
    },
    getHours (date) {
      return date ? date.split(' ')[1].split(':')[0] : null
    },
    getMinutes (date) {
      return date ? date.split(' ')[1].split(':')[1] : null
    },
    getSeconds (date) {
      return date ? date.split(' ')[1].split(':')[2] : null
    },
    getMonthText (date) {
      const month = this.getMonth(date)
      if (month === '01') return 'JAN'
      else if (month === '02') return 'FEV'
      else if (month === '03') return 'MAR'
      else if (month === '04') return 'ABR'
      else if (month === '05') return 'MAI'
      else if (month === '06') return 'JUN'
      else if (month === '07') return 'JUL'
      else if (month === '08') return 'AGO'
      else if (month === '09') return 'SET'
      else if (month === '10') return 'OUT'
      else if (month === '11') return 'NOV'
      else if (month === '12') return 'DEZ'
      else return null
    },
    getMonthTextFull (date) {
      const month = this.getMonth(date)
      if (month === '01') return 'Janeiro'
      else if (month === '02') return 'Fevereiro'
      else if (month === '03') return 'Março'
      else if (month === '04') return 'Abril'
      else if (month === '05') return 'Maio'
      else if (month === '06') return 'Junho'
      else if (month === '07') return 'Julho'
      else if (month === '08') return 'Agosto'
      else if (month === '09') return 'Setembro'
      else if (month === '10') return 'Outubro'
      else if (month === '11') return 'Novembro'
      else if (month === '12') return 'Dezembro'
      else return null
    },
    getDateISO (date) {
      if (!date) return null
      const format = this.getDate(date)
      return `${format.split('/')[2]}-${format.split('/')[1]}-${format.split('/')[0]}`
    },
    formatUTCDate (value) {
      if (!value) return null
      const date = new Date(value)
      date.setUTCHours(0, 0, 0, 0)
      let dd = date.getUTCDate()
      let mm = date.getUTCMonth() + 1
      const yyyy = date.getUTCFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      return dd + '/' + mm + '/' + yyyy
    },
    formatISODate (value) {
      const obj = new Date(value)
      const year = String(obj.getUTCFullYear())
      const month = String(obj.getUTCMonth() + 1).padStart(2, '0')
      const day = String(obj.getUTCDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getDatesQuarter (value) {
      if (!value) return null
      const date = new Date(value)
      const month = date.getMonth()
      if (month >= 0 && month <= 2) {
        return [new Date(date.getFullYear(), 0, 1), new Date(date.getFullYear(), 2, 31)]
      } else if (month >= 3 && month <= 5) {
        return [new Date(date.getFullYear(), 3, 1), new Date(date.getFullYear(), 5, 30)]
      } else if (month >= 6 && month <= 8) {
        return [new Date(date.getFullYear(), 6, 1), new Date(date.getFullYear(), 8, 30)]
      } else if (month >= 9 && month <= 11) {
        return [new Date(date.getFullYear(), 9, 1), new Date(date.getFullYear(), 11, 31)]
      }
    },
    getDatesHalfYear (value) {
      if (!value) return null
      const date = new Date(value)
      const month = date.getMonth()
      if (month >= 0 && month <= 5) {
        return [new Date(date.getFullYear(), 0, 1), new Date(date.getFullYear(), 5, 30)]
      } else if (month >= 6 && month <= 11) {
        return [new Date(date.getFullYear(), 6, 1), new Date(date.getFullYear(), 11, 31)]
      }
    }
  }
}

export default mixin
